import * as siteActions from '@lib/actions/SiteAction';
import { addTranslateToProps, ITranslationProps } from '@lib/i18n/translation';
import Input from '@lib/pages/Input';
import { IChannel, IInputChannel, ISite, IStoreSiteState } from '@lib/types/index';
import { connect, Dispatch } from 'react-redux';
import { withRouter } from 'react-router';



export function mapStateToProps(state: any): IIInputProps {
  const siteState: IStoreSiteState = state.site;
  return addTranslateToProps({
    errorMessage: siteState.errorMessage,
    idDevice: (siteState.site && siteState.site.device ? siteState.site!.device!.id : ''),
    input: siteState.input,
    saving: siteState.saving,
    site: siteState.site,
  })
}

export function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    onGoBack: () => dispatch(siteActions.navigateToDashboard()),
    // onSaveIInput: (input: IInputChannel) => dispatch(actions.asyncSendPasswordAction('')),
    onSaveInput: (idDevice: string, name: string, input: IChannel) => dispatch(siteActions.asyncChannelSaveAction(idDevice, name, input))
  }
}

export interface IIInputProps extends ITranslationProps {
  errorMessage: string;
  idDevice: string;
  input: IInputChannel;
  saving: boolean;
  site: ISite;
}

interface IIInputDispatchProps {
  onGoBack(): void;
  onSaveInput(idDevice: string, name: string, input: IChannel): void;
}

export type IInputProps = IIInputProps & IIInputDispatchProps;

export default withRouter(connect<IIInputProps, IIInputDispatchProps, any>(mapStateToProps, mapDispatchToProps)(Input));


// WEBPACK FOOTER //
// ./src/containers/Input.tsx